import { useDisclosure } from '@chakra-ui/react';

import { useCurrentUser } from '../../../utils/user';
import CopyDiagramModal from '../../CopyDiagramModal';
import BlockedMenuItem from '../BlockedMenuItem';
import TrackedMenuItem from '../TrackedMenuItem';

const CopyDiagramMenuItem: React.FC = () => {
  const disclosure = useDisclosure();
  const { user } = useCurrentUser();

  if (!user?.can_create_sankeys) {
    return (
      <BlockedMenuItem
        value="create-copy"
        label="Create a copy"
        conversionTriggerAction="Copying"
        upgradeMessage="To copy this diagram please upgrade your subscription or delete some of your existing diagrams to free up more diagram slots."
      />
    );
  }

  return (
    <>
      <TrackedMenuItem value="create-copy" onClick={disclosure.onOpen}>
        Create a copy
      </TrackedMenuItem>
      <CopyDiagramModal {...disclosure} />
    </>
  );
};

export default CopyDiagramMenuItem;
